import gql from 'graphql-tag';

export const ADMIN_ORDER_HISTORY_BY_ORDER_ID = gql`
  query adminOrderHistoryByOrderId($input: AdminOrderHistoryInput!) {
    adminOrderHistory(input: $input) {
      id
      adminId
      oldValues
      input
      createdAt
      orderId
      order {
        id
        createdAt
        user {
          id
          firstName
          lastName
        }
        event {
          id
          name
          startDate
          endDate
          openDate
          closeDate
          venue {
            id
            name
            timeZone
          }
        }
      }
      admin {
        id
        firstName
        lastName
        email
      }
      changes
    }
  }
`;
